import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 5F6A5994-FF0D-417E-9845-8BF18225CE3C
 * name send-variant-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/send-variant-outline.svg
 * tags
 */
export const SendVariantOutlineIcon = createSvgIcon(<><path d="M3 20V4L22 12M5 17L16.85 12L5 7V10.5L11 12L5 13.5M5 17V7 13.5Z" /></>, 'SendVariantOutlineIcon');
export default SendVariantOutlineIcon